import React, { useState } from 'react'
import Text from './Text'
import theme from '../theme';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';

// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

export default function Header(props) {

    const { title } = props;

    return (
        <Toolbar>
            <Grid container alignItems="center">
                <div style={{ flex: 1 }}>
                    <Text style={{ fontSize: 20, fontWeight: '600', color: theme.palette.primary.main, marginRight: 10 }}>{title}</Text>
                </div>
            </Grid>
        </Toolbar>
    )
}